import { render } from "./SidebarTable.vue?vue&type=template&id=4becf90f&scoped=true"
import script from "./SidebarTable.vue?vue&type=script&lang=js"
export * from "./SidebarTable.vue?vue&type=script&lang=js"

import "./SidebarTable.vue?vue&type=style&index=0&id=4becf90f&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4becf90f"]])

export default __exports__